export default __webpack_public_path__ + "static/media/my-drive (1).3670a495.png";